'use client';

import { useQuery } from '@tanstack/react-query';

/** A regulation hub topic linked from the Kajian dropdown utility card. */
export interface RegulationHub {
  id: string;
  name: string;
  slug: string;
}

/** Response envelope of the public hubs listing (/api/blog/hubs). */
interface HubsResponse {
  data: RegulationHub[];
}

/**
 * Loads the active regulation hubs so the Kajian dropdown can point its
 * "Regulation Hub" card at the first available hub.
 *
 * The request stays disabled until the dropdown opens so the hubs API is
 * not hit on every page load, mirroring the upcoming-event fetch. Once
 * fetched, the result is cached for a few minutes.
 */
export function useRegulationHubs(enabled: boolean) {
  return useQuery<HubsResponse>({
    queryKey: ['blog-hubs', 'active'],
    queryFn: async () => {
      const res = await fetch('/api/blog/hubs');
      if (!res.ok) throw new Error('Failed to fetch regulation hubs');
      return res.json();
    },
    enabled,
    staleTime: 1000 * 60 * 5,
    retry: 3,
  });
}
